<template>
  <div class="consulting-answer">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Dados do dúvida</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>Cliente</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="consulting.user.client.name"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for>Nome do Usuário</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="consulting.user.name"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for>Email do Usuário</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="consulting.user.contact.email"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-9">
                  <div class="form-group">
                    <label for>Assunto</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="consulting.subject"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for>Data</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatDate(consulting.created_at)"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>Pergunta</label>
                    <textarea
                      cols="30"
                      rows="5"
                      class="form-control"
                      v-model="consulting.question"
                      disabled
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Resposta
                      <span class="required-field">*</span>
                    </label>
                    <text-editor-component
                      :textContent="consulting_answer.answer"
                      @updateContentComponent="updateContent"
                    ></text-editor-component>
                  </div>
                </div>
                <div class="col-lg-9 col-12">
                  <div class="form-group">
                    <label for>
                      Consultor
                      <span class="required-field">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-model="consulting_answer.user_id"
                    >
                      <option
                        v-for="consultant in consultants"
                        :value="consultant.id"
                        v-bind:key="consultant.id"
                      >
                        {{ consultant.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3 col-12">
                  <div class="form-group">
                    <label for>Status</label>
                    <select v-model="consulting.status" class="form-control">
                      <option
                        v-for="item in status"
                        :value="item"
                        v-bind:key="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12" v-if="consulting.files">
                  <label for>Anexos da Pergunta</label>
                  <b-table
                    :fields="fieldsFiles"
                    :items="consulting.files"
                    sticky-header
                  >
                    <template v-slot:cell(id)="data">
                      <div class="d-flex float-right">
                        <a
                          :href="data.item.file_url"
                          v-if="data.item.id"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button class="btn btn-primary">
                            <i
                              class="fa fa-external-link"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="col-12">
                  <div class="form-group d-flex">
                    <b-form-file
                      ref="newfileinput"
                      placeholder="Escolha um arquivo"
                      drop-placeholder="Arraste o arquivo aqui..."
                      browse-text="Procurar"
                      v-on:change="uploadFile"
                    ></b-form-file>
                    <button
                      class="btn btn-success btn-add-file"
                      v-on:click="addFile()"
                      :disabled="!canAddFile()"
                      v-bind:key="refreshCondition"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>

                <div class="col-12" v-if="consulting_answer.files">
                  <label for>Anexos da Resposta</label>
                  <b-table
                    :fields="fieldsFiles"
                    :items="consulting_answer.files"
                    sticky-header
                  >
                    <template v-slot:cell(id)="data">
                      <div class="d-flex actions-btn">
                        <button
                          class="btn btn-danger"
                          v-on:click="removeFile(data)"
                        >
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                        <a
                          :href="data.item.file_url"
                          v-if="data.item.id"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button class="btn btn-primary">
                            <i
                              class="fa fa-external-link"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div
                class="row"
                v-if="consulting.rating > 0 || consulting.rating_comment"
              >
                <div class="col-lg-9 col-12">
                  <div class="form-group">
                    <label for>Avaliação da resposta</label>
                    <input
                      type="text"
                      v-model="consulting.rating_comment"
                      class="form-control"
                      placeholder="Comentários"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-12 ratting-col">
                  <!-- <i class="fa fa-star rating-star" aria-hidden="true"></i> -->
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(1),
                      'fa-star-o empty': !isRatingPoint(1),
                    }"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(2),
                      'fa-star-o empty': !isRatingPoint(2),
                    }"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(3),
                      'fa-star-o empty': !isRatingPoint(3),
                    }"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(4),
                      'fa-star-o empty': !isRatingPoint(4),
                    }"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa ratting-star"
                    v-bind:class="{
                      'fa-star': isRatingPoint(5),
                      'fa-star-o empty': !isRatingPoint(5),
                    }"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-primary float-left"
                    v-on:click="destroy(consulting.id)"
                  >
                    Deletar
                  </button>
                  <button
                    class="btn btn-primary float-right"
                    v-on:click="save()"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
import moment from "moment";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import consulting_answer_validate from "@/imports/validator/models/consulting-answer";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";

export default {
  name: "consulting-answer",
  props: {
    id: Number,
  },
  components: {
    TextEditorComponent,
  },
  data() {
    return {
      consulting: {},
      consulting_answer: {
        files: [],
      },
      formType: "create",
      consultants: [],
      newFile: {},
      tempFile: "",
      status: [],
      refreshCondition: false,
      fieldsFiles: [
        { key: "name", label: "Nome", class: "name-cell" },
        { key: "id", label: "Ações", class: "remove-cell" },
      ],
      items: [
        {
          text: "Consultoria",
          route: "admin.consultings",
        },
        {
          text: "Dúvida",
          active: true,
        },
      ],
    };
  },
  mounted() {
    if (this.id) {
      bus.$emit("changeLoading", false);
      this.getCreateParams();
    }
  },
  methods: {
    getDataObject: function (id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/consultings/${id}`)
        .then((response) => {
          this.consulting = response.data;
          this.consulting.files = response.data.consulting_files;

          if (this.consulting.consulting_answer) {
            this.consulting_answer = this.consulting.consulting_answer;
            this.consulting_answer.files =
              this.consulting_answer.consulting_answer_files;
            this.formType = "edit";
          }
          if (this.consulting.exceed_limit) {
            Swal.fire({
              title: "Atenção",
              text: "Esse cliente ja excedeu o seu limite de consultorias.",
              icon: "warning",
            });
          }
          bus.$emit("changeLoading", false);
        });
    },
    getCreateParams: function () {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/consultings/create`)
        .then((data) => {
          this.status = data.data.status;
          this.consultants = data.data.consultants;
          this.getDataObject(this.id);
        });
    },
    updateContent: function (val) {
      this.consulting_answer.answer = val;
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    uploadFile: function (e) {
      const file = e.target.files[0];
      if (!file.type.includes("/pdf")) {
        Swal.fire({
          title: "Arquivo não suportado. Insira um PDF.",
          icon: "error",
        });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.tempFile = event.target.result;
          this.newFile.file = file;
          this.refreshCondition = !this.refreshCondition;
        };
        reader.readAsDataURL(file);
      }
    },
    addFile: function () {
      this.consulting_answer.files.push(this.newFile.file);
      this.newFile = {};
      this.$refs.newfileinput.reset();
    },
    canAddFile: function () {
      return this.newFile.file != null;
    },
    removeFile: function (file) {
      if (file.item.id) {
        let index = this.consulting_answer.files.findIndex((el) => {
          return el.id == file.item.id;
        });
        this.consulting_answer.files.splice(index, 1);
      } else {
        this.consulting_answer.files.splice(file.index, 1);
      }
    },
    isRatingPoint: function (position) {
      return this.consulting.rating >= position;
    },
    getObjToFormData(dataObj) {
      let arrObj = Object.entries(dataObj);
      let formData = new FormData();
      arrObj.forEach((el) => {
        if (Array.isArray(el[1])) {
          el[1].forEach((subEl) => {
            formData.append(el[0] + "[]", subEl);
          });
        } else {
          formData.append(el[0], el[1]);
        }
      });

      return formData;
    },
    save: function () {
      let errors = validator.validate(
        this.consulting_answer,
        consulting_answer_validate.model
      );
      if (errors.length == 0) {
        bus.$emit("changeLoading", true);
        this.consulting.consulting_answer = this.consulting_answer;
        let dataObj = JSON.parse(JSON.stringify(this.consulting));
        dataObj.consulting_answer = JSON.stringify(dataObj.consulting_answer);
        dataObj.answer_files = JSON.stringify(this.consulting_answer.files);
        dataObj.new_files = this.consulting_answer.files;

        let data = this.getObjToFormData(dataObj);
        data.append("_method", "PUT");

        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/consultings/${this.consulting.id}`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              enctype: "multipart/form-data",
            },
          }
        );

        promise.then((response) => {
          bus.$emit("changeLoading", false);
          Swal.fire({
            title: "Dúvida respondida com sucesso",
            icon: "success",
            onClose: () => {
              this.$router.push({ name: "admin.consultings" });
            },
          });
        });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach((el) => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning",
        });
      }
    },
    destroy: function (id) {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          bus.$emit("changeLoading", true);
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/consultings/${id}`
          );

          promise.then((response) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.consultings" });
              },
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.ratting-col {
  padding-top: 35px;
  .ratting-star {
    font-size: 28px;
    margin-right: 5px;
  }
  .ratting-star:hover {
    cursor: pointer;
  }
  .fa-star {
    color: gold;
  }
}
.actions-btn {
  button {
    margin-left: 3px;
    margin-right: 3px;
  }
}
.btn-add-file {
  margin-left: 8px;
}
.name-cell {
  width: 90%;
}
.remove-cell {
  width: 10%;
}
</style>